export default "__VITE_ASSET__d4c01cdc__"